import Breadcrumb from "components/Common/Breadcrumb"
import React from "react"
import { Card, CardBody } from "reactstrap"
import pdfIcon from "../../../assets/images/icons/file-type.svg"
import downloadIcon from "../../../assets/images/download.png"

const TDSReports = ({ data, title }) => {
  if (data?.data?.length > 0)
    return (
      <Card>
        <div className="page-search-title">
          <Breadcrumb title={title} />
        </div>
        <CardBody>
          <div className="playlist-wrapper-section mt-5">
            {data.data.map((item, index) => (
              <div key={`document_${index}`} className="playlist-card-box ">
                <div className="align-self-center text-center">
                  <img src={pdfIcon} alt="Download PDF" />
                </div>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    marginTop: "14px",
                    marginBottom: "14px",
                  }}
                >
                  {item.title}
                </p>

                <div
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "14px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                    color: "#09518C",
                  }}
                >
                  <a
                    href={item.document_url}
                    className="d-flex flex-column play-icon"
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#09518C", fontSize: "16px" }}
                  >
                    Download
                  </a>
                  <img height={"20px"} src={downloadIcon} />
                </div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    )
}

export default TDSReports
